import { useCookies } from 'react-cookie';

import { COOKIE_OPTIONS, COOKIES_KEYS, ROUTES } from '@/constants';
import { toSafeRedirectPath } from '@/utils/toSafeRedirectPath';

export const useLoginUrlData = () => {
  const [cookies, setCookies] = useCookies([
    COOKIES_KEYS.ORIGIN_HOST,
    COOKIES_KEYS.LOGIN_PARAMS,
  ]);

  const hostOrigin: string | undefined = cookies.hostOrigin;
  const loginParams: string | undefined = cookies.loginParams;
  const requestedRedirect = new URLSearchParams(loginParams).get('redirect');

  const saveLoginUrlData = (redirect?: string) => {
    const url = new URL(location.href);

    if (redirect) {
      url.searchParams.set('redirect', redirect);
    }

    setCookies(COOKIES_KEYS.ORIGIN_HOST, url.origin, COOKIE_OPTIONS);
    setCookies(
      COOKIES_KEYS.LOGIN_PARAMS,
      url.searchParams.toString(),
      COOKIE_OPTIONS,
    );
  };

  return {
    redirect: requestedRedirect
      ? toSafeRedirectPath(requestedRedirect, ROUTES.HOME.pathname)
      : null,
    hostOrigin,
    loginParams,
    saveLoginUrlData,
  };
};
